import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api } from "../../lib/api";
import { StickyBack } from "../../components/StickyBack";
import { ClosingFeedbacks } from "../../components/ClosingFeedbacks";
import { ProgIcon } from "../../components/ProgIcon";

export default function HubClosing() {
  const navigate = useNavigate();
  const [locked, setLocked] = useState(null);
  useEffect(() => {
    api.get("/client/hub-pages").then(({ data }) => setLocked(!!data.closing_locked)).catch(() => setLocked(false));
  }, []);
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl space-y-8">
      <StickyBack onClick={() => navigate("/espace/hub")}>Revenir à The Elevate Hub</StickyBack>
      <div className="flex items-start gap-4">
        <ProgIcon slug="strategie-vente" size="lg" />
        <div>
          <h1 className="font-sans text-2xl font-medium text-ink sm:text-4xl">Feedback de tes calls de closing</h1>
          <p className="mt-1 text-sm font-light text-ink-muted">Partage-moi le lien de chaque appel, je t'écris mon retour juste en dessous.</p>
        </div>
      </div>
      {locked === true && (
        <div data-testid="closing-locked" className="flex items-center gap-3 rounded-2xl border border-line bg-white p-6 text-ink-muted"><Lock size={18} /> Cette ressource n'est pas encore disponible.</div>
      )}
      {locked === false && <ClosingFeedbacks />}
    </motion.div>
  );
}
